import React from 'react';
import { L2_ICON_SIZES } from '../../constants';
import type { L2IconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const ComplianceServicesL2Icon = ({
  size = 'sm',
  dataTrackTag = pascalToSnake('ComplianceServicesL2Icon'),
}: L2IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L2_ICON_SIZES[size]}
    height={L2_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 48 48"
    data-track-tag={dataTrackTag}
  >
    <g clipPath="url(#compliance_services_svg__a)">
      <g filter="url(#compliance_services_svg__b)">
        <path
          fill="#fff"
          d="M6 11.474v12.609a18 18 0 0 0 8.83 15.49l8.151 4.824a2 2 0 0 0 2.038 0l8.15-4.825A18 18 0 0 0 42 24.082V11.475a2 2 0 0 0-1.265-1.86l-16-6.323a2 2 0 0 0-1.47 0l-16 6.323A2 2 0 0 0 6 11.474"
        />
        <path
          stroke="#E4E5E7"
          strokeWidth={0.5}
          d="M6.25 24.083V11.474a1.75 1.75 0 0 1 1.107-1.627l16-6.324a1.75 1.75 0 0 1 1.286 0l16 6.324a1.75 1.75 0 0 1 1.107 1.627v12.609a17.75 17.75 0 0 1-8.708 15.274l-8.15 4.825a1.75 1.75 0 0 1-1.783 0l-8.15-4.825A17.75 17.75 0 0 1 6.25 24.083Z"
        />
      </g>
      <path
        fill="url(#compliance_services_svg__c)"
        fillRule="evenodd"
        d="M9 13.444v9.309a18 18 0 0 0 4.31 11.688 13 13 0 0 1 21.255.144A18 18 0 0 0 39 22.753v-9.31a2 2 0 0 0-1.247-1.852l-13-5.285a2 2 0 0 0-1.506 0l-13 5.285A2 2 0 0 0 9 13.444M29.887 20a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
        clipRule="evenodd"
      />
      <g filter="url(#compliance_services_svg__d)">
        <circle cx={34} cy={37} r={8} fill="#fff" />
        <circle cx={34} cy={37} r={7.75} stroke="#E4E5E7" strokeWidth={0.5} />
      </g>
      <path stroke="#222325" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m31 37.5 2.5 2 4.5-5" />
    </g>
    <defs>
      <filter
        id="compliance_services_svg__b"
        width={42}
        height={47.525}
        x={3}
        y={0.151}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2988_22572" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2988_22572" result="shape" />
      </filter>
      <filter
        id="compliance_services_svg__d"
        width={22}
        height={22}
        x={23}
        y={26}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2988_22572" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2988_22572" result="shape" />
      </filter>
      <linearGradient
        id="compliance_services_svg__c"
        x1={9}
        x2={50.152}
        y1={-2.369}
        y2={12.303}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005C25" />
        <stop offset={1} stopColor="#BBCE00" />
      </linearGradient>
      <clipPath id="compliance_services_svg__a">
        <rect width={48} height={48} fill="#fff" rx={5.565} />
      </clipPath>
    </defs>
  </svg>
);
ComplianceServicesL2Icon.displayName = 'ComplianceServicesL2Icon';
export default ComplianceServicesL2Icon;
